<template>
  <div class="header">
    <a href="https://sbgrid.co.kr" target="_blank"><img src="/images/SBGrid.png" alt="SBGrid"/><span class="hd-text">SBGrid는</span></a>&nbsp;
    <img src="/images/Vue.png" alt="SBGrid"/><span class="hd-text">Vue Framework를 혼용하여 사용이 가능합니다.</span>
  </div>
</template>

<script>

export default {

}
</script>

<style scoped>
a {
    text-decoration: none;
}
.header {
    text-align: center;
    height: 8vh;
    line-height: 8vh;
    background: #4ccd91;
}
.header img { vertical-align: middle; padding: 0 10px;}
.hd-text {
    color: #fff;
    font-size: 20pt;
    vertical-align: middle;
}
</style>